(function ($) {
  "use strict";

  const ajaxUrl       = hitech_ajax.ajaxurl;
  const fetchPodcasts = hitech_ajax.fetchPodcasts;
  let canBeLoaded     = true;

  /*** Podcats Tabs Element ***/
  const loadPodcastsBtn = document.getElementById('loadPodcastsBtn');

  /* Switch Tabs. DESKTOP */
  $(document).on('click', '.js_podcastTab', function(e) {
    e.preventDefault();

    const catTargetID = $(this).attr('data-cat-target');
    const dataCatCount = $(this).attr('data-cat-count');
    const $tabItem    = $(document).find(`.js_podcastTabItem[data-cat-id=${catTargetID}]`);

    const catCount  = Number.parseInt(dataCatCount);

    if ($tabItem.length) {
      const catID = $tabItem.attr('data-cat-id');

      if (catID !== catTargetID) {
        return false;
      }

      if ($tabItem.hasClass('podcastTabs_bodyItem-active')) {
        return false;
      }

      /* Tabs */
      $(document).find('.js_podcastTab.podcastTabs_tabActive').removeClass('podcastTabs_tabActive');
      $(this).addClass('podcastTabs_tabActive');

      /* Body */
      $(document).find('.js_podcastTabItem.podcastTabs_bodyItem-active').removeClass('podcastTabs_bodyItem-active');
      $tabItem.addClass('podcastTabs_bodyItem-active');

      /* Hide Load More button if no more posts in current category */
      const podcastItems = $tabItem.find('.hitechPodcast');

      if (podcastItems.length >= catCount) {
        loadPodcastsBtn.style.display = 'none';
      } else {
        loadPodcastsBtn.style.display = 'inline-flex';
      }
    }

  });


  /* Switch Tabs. MOBILE */
  $(document).on('change', '#podcastTabsSelect', function(e) {
    if (this.value) {
      const selectedOption  = this.options[this.selectedIndex];
      const dataCatCount    = selectedOption.dataset.catCount;
      const catCount        = Number.parseInt(dataCatCount);
      const $tabItem        = $(document).find(`.js_podcastTabItem[data-cat-id=${this.value}]`);

      if ($tabItem.length) {
        const catID = $tabItem.attr('data-cat-id');

        if (catID !== this.value) {
          return false;
        }

        $(document).find('.js_podcastTabItem.podcastTabs_bodyItem-active').removeClass('podcastTabs_bodyItem-active');
        $tabItem.addClass('podcastTabs_bodyItem-active');

        /* Hide Load More button if no more posts in current category */
        const podcastItems = $tabItem.find('.hitechPodcast');

        if (podcastItems.length >= catCount) {
          loadPodcastsBtn.style.display = 'none';
        } else {
          loadPodcastsBtn.style.display = 'inline-flex';
        }
      }
    }
  });


  /* Load more on button click */
  $(document).on('click', '#loadPodcastsBtn', function(e) {
    e.preventDefault();

    const btn = $(this);

    if (btn.hasClass('brandButton_disabled')) {
      return false;
    }

    const $activeTabItem = $(document).find('.js_podcastTabItem.podcastTabs_bodyItem-active');

    if (!$activeTabItem.length) {
      return false;
    }

    const catID = $activeTabItem.attr('data-cat-id');

    if (!catID) {
      return false;
    }

    const podcastItems = $activeTabItem.find('.hitechPodcast');
    const loadedPodcastsCount = podcastItems.length;

    $.post({
      url: ajaxUrl,
      data: {
        'action': fetchPodcasts,
        'category_id': catID,
        'offset': loadedPodcastsCount,
      },
      beforeSend: function(xhr) {
        // AJAX is in process, shouldn't run again until complete
        canBeLoaded = false;
        btn.addClass('brandButton_disabled');
      },
      success: function(data) {
        // console.log('response: ', data);

        if (data) {
          $activeTabItem.find('.hitechPodcasts').append(data);

          const $activeTab    = $(document).find('.js_podcastTabItem.podcastTabs_bodyItem-active');
          const dataCatCount  = $activeTab.attr('data-cat-count');
          const catCount      = Number.parseInt(dataCatCount);

          const $podcastItems = $activeTab.find('.hitechPodcast');
          const loadedPodcastsCount = $podcastItems.length;

          if (loadedPodcastsCount >= catCount) {
            loadPodcastsBtn.style.display = 'none';
          }
        }
      },
      fail: function (result) {
        // console.log('fail: ', result);
      }
    }).done(function (result){
      // console.log('Done', result);
      canBeLoaded = true;     // the AJAX is completed
      btn.removeClass('brandButton_disabled');
    });

  });

})(jQuery);
